import { render } from "./notificacionRetribucion.vue?vue&type=template&id=47a17e5a"
import script from "./notificacionRetribucion.vue?vue&type=script&lang=js"
export * from "./notificacionRetribucion.vue?vue&type=script&lang=js"

import "./notificacionRetribucion.vue?vue&type=style&index=0&id=47a17e5a&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__